import getAllGatewayIds from '@app/pages/wan/WanHelper';

const setControllerServers = (controller, sites, wans) => {
  var controllerSites = [];
  var assignedServers = [];
  var availableServers = [];
  let wanGateways = getAllGatewayIds(wans);

  controller.Servers.forEach((server) => {
    if (server.Tunnels.length > 0) {
      assignedServers.push(server);

      let foundSite;

      server.Tunnels.forEach((tunnel) => {
        foundSite = sites.find((site) => site.Tunnels.find((siteTunnel) => tunnel.id === siteTunnel.id));
        
        // determine mode from tunnel's isActive field
        const matchingTunnel = foundSite?.Tunnels?.find((siteTunnel) => tunnel.id === siteTunnel.id);
        const isActive = matchingTunnel?.isActive === true;
        const tunnelMode = isActive ? 'Active' : 'Standby';
        
        controllerSites.push({ 
          ...foundSite, 
          server, 
          displayName: foundSite.name || foundSite.address1,
          tunnelMode: tunnelMode
        });
      });
    } else if (wanGateways.includes(server.id)) {

      assignedServers.push(server);
    } else {
      availableServers.push(server);
    }
  });

  return {
    sites: controllerSites,
    assigned: assignedServers,
    available: availableServers,
  };
};

export default setControllerServers;